import React from "react";
import LegalPage from "../../components/Kids/LegalPage";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";

export default function KidsTermsConditions() {
  return (
    <LegalPage title="Terms &amp; Conditions" updated="July 25, 2026">
      <Seo
        {...SEO["/kids/terms"]}
        path="/kids/terms"
      />

      <p>
        These terms govern use of Cabil Kids on the website and mobile app. By creating an
        account you agree to them on behalf of yourself and any child profiles you add.
      </p>

      <h2>Who can create an account</h2>
      <p>
        An account may only be created by a parent or legal guardian who is at least 18 years
        old. Children access Cabil Kids through a profile the parent creates, either by handing
        the parent's device to the child or by the child signing in with a PIN the parent set —
        a child never registers their own account.
      </p>

      <h2>The free trial and subscriptions</h2>
      <p>
        New accounts start with a 14-day free trial, no credit card required. After the trial (or
        whenever a parent chooses to change plans), a subscription request is reviewed and
        activated by our team; where online payment is available, it is processed by our payment
        provider and is never handled by a child's session.
      </p>

      <h2>Acceptable use</h2>
      <ul>
        <li>Use Cabil Kids only for its intended purpose: a child's learning, under a parent's supervision.</li>
        <li>Don't attempt to bypass account restrictions, rate limits, or security controls.</li>
        <li>Don't upload or approve Watch Zone content you don't have the right to share.</li>
        <li>Keep your password and any child PINs reasonably private.</li>
      </ul>

      <h2>Content and AI features</h2>
      <p>
        Cabi (the AI study buddy) and the AI game generator produce responses automatically and
        may occasionally be inaccurate — they're a learning aid, not a substitute for a parent's
        or teacher's judgment. Please review AI-generated content before relying on it.
      </p>

      <h2>Account deletion</h2>
      <p>
        You may delete your account at any time from Settings (web) or the Profile screen (app).
        This immediately signs the account out on every device and deactivates access. See our{" "}
        <a href="/kids/privacy">Privacy Policy</a> for how to request full data erasure.
      </p>

      <h2>Availability and changes</h2>
      <p>
        We work to keep Cabil Kids available and reliable but don't guarantee uninterrupted
        access. Features, pricing, and these terms may change; where a change is material, we'll
        make reasonable efforts to notify parents in advance.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        Cabil Kids is provided "as is." To the extent permitted by law, we aren't liable for
        indirect or incidental damages arising from use of the app. Nothing here limits liability
        that can't legally be limited.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about these terms: message us on{" "}
        <a href="https://wa.me/+923314622245" target="_blank" rel="noreferrer">WhatsApp</a>{" "}
        or through the <a href="/contact-us">Contact page</a>.
      </p>
    </LegalPage>
  );
}
